import React, { Component } from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';
import { Popover, ListGroup, ListGroupItem } from 'reactstrap';
import shortid from 'shortid';

import { ID } from 'app/PreviewPane/const';
import { IconButton } from 'ui/Components';
import { options } from 'ui/Icons';

import styles from './ContextMenu.css';

/**
 * Renders a context menu icon
 * @param {Array} actions - actions items to be given on click
 * @param {Function} onActionSelect - action to be executed on action click
 * @returns {React.Component} the context menu icon
 */
class ContextMenu extends Component {
  static propTypes = {
    actions: propTypes.arrayOf(
      propTypes.shape({
        text: propTypes.oneOfType([propTypes.string, propTypes.object]).isRequired,
        action: propTypes.string.isRequired,
        disabled: propTypes.bool
      })
    ),
    onActionSelect: propTypes.func,
    icon: propTypes.string,
    popoverPlacement: propTypes.string,
    rem: propTypes.number,
    isReadonly: propTypes.bool
  };

  static defaultProps = {
    actions: [],
    icon: options,
    popoverPlacement: 'bottom',
    onActionSelect: null,
    rem: 1,
    isReadonly: false
  };

  constructor(props) {
    super(props);
    this.state = {
      popoverOpen: false,
      ellipsesClass: styles.ellipses,
      id: `cm-${shortid.generate()}`
    };
    this.togglePopover = this.togglePopover.bind(this);
    this.onItemClick = this.onItemClick.bind(this);
  }

  /**
   * handles click on action item
   * @param {string} action - selected action
   */
  onItemClick(action) {
    // This click event is in invoked to make popover disappear after clicking on an menu item.
    document.body.click();
    if (this.props.onActionSelect) {
      this.props.onActionSelect(action);
    }
  }

  /**
   * toggles popover on icon click
   */
  togglePopover() {
    this.setState(ps => ({
      popoverOpen: !ps.popoverOpen,
      ellipsesClass: !ps.popoverOpen ? styles.ellipsesClicked : styles.ellipses
    }));
  }

  /**
   * Renders actions items as context menu
   * @param {Array} actions - actions array
   * @returns {Component} returns context menu component
   */
  renderActions(actions) {
    if (Array.isArray(actions)) {
      return (
        <ListGroup className={styles.listGroup}>
          {actions.map(item => (
            <ListGroupItem
              id={ID.CONTEXT_MENU}
              data-test-id={`context-menu-action-${item.action}`}
              key={item.text}
              className={item.disabled ? 'text-muted' : styles.listItem}
              onClick={() => (item.disabled ? {} : this.onItemClick(item.action))}
            >
              {item.text}
            </ListGroupItem>
          ))}
        </ListGroup>
      );
    }
    return '';
  }

  render() {
    const { actions, icon, popoverPlacement, rem, isReadonly } = this.props;
    const { ellipsesClass, popoverOpen, id } = this.state;
    return (
      <div
        id={id}
        className={classnames('p-2', ellipsesClass, styles.wrapper)}
        data-test-id="ellipses-icon"
        role="presentation"
        onClick={this.togglePopover}
      >
        <IconButton icon={icon} isReadonly={isReadonly} noMargin rem={rem} />
        <Popover
          placement={popoverPlacement}
          target={id}
          isOpen={popoverOpen}
          toggle={this.togglePopover}
          trigger="legacy"
          delay={0}
        >
          {this.renderActions(actions)}
        </Popover>
      </div>
    );
  }
}

export default ContextMenu;
